import { Outlet, useParams } from 'react-router-dom'

import { CardPaymentsDataTable } from 'modules/banking/components/CardPaymentsDataTable'

const AccountCardPaymentsDataTable = () => {
  const { id } = useParams<{ id: string }>()

  return (
    <>
      <Outlet />
      <CardPaymentsDataTable
        accountId={Number(id)}
        tableIdentifier={`AccountCardPaymentsTable/${id}`}
        showInsights
      />
    </>
  )
}

export default AccountCardPaymentsDataTable
